import { action, makeAutoObservable } from "mobx";
import INTOUCH_API from "../services/Api";
import PersonalAccount from "./PersonalAccount";
import { disableRubberBandScroll } from "../utils/disableRubberBand";

class DemonstrationStore {
  step = 1;
  isOpen = false;
  isCheckedCard = false;
  demonstrationProps = {};
  refCard = {};
  demonstrationFinished = false;
  finished = false;

  constructor() {
    makeAutoObservable(this);
  }

  setRefCard(ref) {
    this.refCard = ref;
  }

  resetDemonstration() {
    this.step = 1;
    this.isOpen = false;
    this.isCheckedCard = false;
    this.demonstrationProps = {};
    this.refCard = {};
    this.demonstrationFinished = false;
    this.finished = false;
  }

  async openDemonstration(props = {}) {
    if (!PersonalAccount.hasFinishedDemonstration(props.id)) {
        this.isOpen = true;
        this.demonstrationProps = props;
        disableRubberBandScroll();
    }
  }

  checkCard() {
    setTimeout(() => {
      this.isCheckedCard = true;
    }, 2000);
  }

  nextStep() {
    this.step++;
  }

  async closeDemonstration({ gameId, userId }) {
    this.finished = true;
    this.isOpen = false;

    await INTOUCH_API.requestManager(
      "demonstration_finish",
      { gameId, id: userId },
      action((response) => {
        this.demonstrationFinished = true;
      }),
      action((error) => {
        this.demonstrationFinished = false;
      })
    );
  }
}

export const demonstrationStore = new DemonstrationStore();
